<template>
  <BaseButton :variant="variant" @click="$emit('click')" :disabled="disabled">
    <BaseIcon v-if="isShowIcon" icon-name="approve" :width="iconWidth" :height="iconHeight">
      <IconApprove></IconApprove>
    </BaseIcon>
    <slot></slot>
  </BaseButton>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import IconApprove from '@/components/icon/IconApprove.vue';
import buttonMixin from '@/mixins/button';

export default {
  mixins: [buttonMixin],
  components: {
    BaseIcon,
    IconApprove,
  },
  props: {
    variant: { type: String, default: 'success' },
  },
};
</script>
